import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/booking-details-request'
)({
  component: () => <div>CleanerBookingDetailsRequest</div>,
});
